import axios from 'axios';

export interface FilingDataQ4 {
  GetEdgarFilingListResult: {
    DocumentList: {
      DocumentType: 'CONVPDF' | string;
      Url: string;
    }[];
    FilingTypeMnemonic: string;
    FilingDate: string;
    FilingDescription: string;
    FilingId: string;
  }[];
}

export const getFinancialsQ4 = async () => {
  try {
    // Fetch data from SEC API
    const response = await axios.get<FilingDataQ4>(
      'https://lemonade2019ipo.q4web.com/feed/SECFiling.svc/GetEdgarFilingList?apiKey=lemonade040305&LanguageId=1&exchange=CIK&symbol=0001691421&formGroupIdList=&excludeNoDocuments=true&pageSize=-1&pageNumber=0&tagList=&includeTags=true&year=-1&excludeSelection=1',
    );

    console.log('🔥 response', response);

    const filings = response.data.GetEdgarFilingListResult;

    const yearValues = filings.map(filing => new Date(filing.FilingDate).getFullYear().toString());

    const uniqueYears: string[] = Array.from(new Set(yearValues)).sort(
      (a, b) => parseInt(b as string) - parseInt(a as string),
    ) as string[];

    return {
      filings,
      uniqueYears,
    };
  } catch (error) {
    console.error('Error fetching Q4 filings data:', error);
    // Return empty filings array in case of an error
    return {
      filings: [],
      uniqueYears: [],
    };
  }
};
